import React, { useContext } from 'react';
import styles from './style.module.css';
import MobileContext from 'context/MobileContext';
const MobileHeader = ({ headerName }) => {
  const isMobile = useContext(MobileContext);
  return (
    <>
      <p className={`${styles.heading} ${!isMobile ? styles.mob : ''}`}>
        {headerName === 'Forgot Password' ||
        headerName === 'Forgot Password Email Sent' ? (
          <>
            Forgot <br /> Password
          </>
        ) : headerName === 'Send One-Time Login Link' ? (
          <>
            Send One-Time <br /> Login Link
          </>
        ) : (
          <>
            Welcome to the <br /> Member Portal.
          </>
        )}
      </p>
    </>
  );
};

export default MobileHeader;
